import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=0b27c61c&"
import script from "./Reports.vue?vue&type=script&lang=ts&"
export * from "./Reports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports